<style>
    .mat-column-openOrder, .mat-column-Extension {
        flex: 0 0 80px;
    }

    .mat-column-Alias {
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .mat-column-OnRentDate, .mat-column-InvoiceAt, .mat-column-Price, .mat-column-Method, .mat-column-ExtendToDate {
        flex: 0 0 150px;
    }

    .mat-column-OffRentDate {
        flex: 0 0 150px;
    }

    .mat-column-EndContract {
        flex: 0 0 50px;
    }

    .mat-column-RegNo, .mat-column-DLLContractId, .mat-column-XalAccountNo, .mat-column-ContractType, .mat-column-OwnerId {
        flex: 0 0 80px;
    }

    .handled {
        color: #1e9b38;
        background: rgba(27,117,50,0.2);
    }

    .blocked {
        color: #e52a16;
        background: rgba(229,42,22,0.2);
    }
</style>

<t4-header icon="glyphicon-stats" title="{{'TO.Dashboard.Headline' |translate : 'Dashboard' }}">
  <button mat-button color="primary" *ngIf="Settings.isInAny(['OneWayAdmin'])" (click)="SendPurchaseOrders()"><mat-icon>send</mat-icon><span>{{ 'TO.BackOffice.SendPurchaseOrders' | translate : 'Send purchase orders' }}</span></button>
</t4-header>

<mat-tab-group dynamicHeight="true">
  <mat-tab label="{{'TO.Dashboard.InvoiceQueue' |translate : 'Invoice queue' }}">

    <t4-container style="position: fixed !important; z-index: 1000; bottom: 0px; width: calc(100% - 240px); border: 1px solid black;" *ngIf="enableMultiSelect">
      <div class="row">
        <div class="col-3" style="padding: 3px;"></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone() | date : 'MMMM' }}</b></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone().add('month', 1) | date : 'MMMM' }}</b></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone().add('month', 2) | date : 'MMMM' }}</b></div>
      </div>
      <div class="row">
        <div class="col-3" style="padding: 3px;"><b>{{ 'TO.BackOffice.lblSelected' | translate : 'Selected' }}</b></div>
        <div class="col-2" style="padding: 3px;">{{ sel1 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ sel2 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ sel3 | currency }}</div>
      </div>
    </t4-container>

    <t4-container title="{{'TO.Dashboard.InvoiceSummary' |translate : 'Summary' }}">
      <div class="row">
        <div class="col-3" style="padding: 3px;"></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone() | date : 'MMMM' }}</b></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone().add('month', 1) | date : 'MMMM' }}</b></div>
        <div class="col-2" style="padding: 3px;"><b>{{ today.clone().add('month', 2) | date : 'MMMM' }}</b></div>
        
      </div>
      <div class="row">
        <div class="col-3" style="padding: 3px;"><b>{{ 'TO.BackOffice.lblSweden' | translate : 'Sweden' }}</b></div>
        <div class="col-2" style="padding: 3px;">{{ se1 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ se2 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ se3 | currency }}</div>
        
      </div>
      <div class="row">
        <div class="col-3" style="padding: 3px;"><b>{{ 'TO.BackOffice.lblDenmark' | translate : 'Denmark' }}</b></div>
        <div class="col-2" style="padding: 3px;">{{ dk1 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ dk2 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ dk3 | currency }}</div>
        
      </div>
      <div class="row">
        <div class="col-3" style="padding: 3px;"><b>{{ 'TO.BackOffice.lblNorway' | translate : 'Norway' }}</b></div>
        <div class="col-2" style="padding: 3px;">{{ no1 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ no2 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ no3 | currency }}</div>
        
      </div>
      <div class="row">
        <div class="col-3" style="padding: 3px;"><b>{{ 'TO.BackOffice.lblSelected' | translate : 'Selected' }}</b></div>
        <div class="col-2" style="padding: 3px;">{{ sel1 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ sel2 | currency }}</div>
        <div class="col-2" style="padding: 3px;">{{ sel3 | currency }}</div>
      </div>
    </t4-container>
    <button *ngIf="!enableMultiSelect && !isReadOnly" (click)="beginComplete()" mat-raised-button id="cmdBeginComplete" style="margin: 15px;" type="button">{{ 'TO_BackOffice_cmdMarkAsSold' | translate : 'Mark as sold' }}</button>
    <t4-container title="{{'TO.Dashboard.InvoiceDetails' |translate : 'Details' }}">
      <t4-data-table *ngIf="showInvoiceQueue" #tblInvoice apiMethod="/TurboOrder/GetInvoicePipe" [allowMultiSelect]="enableMultiSelect" [autoGenerateColumns]="false" headline="{{'TO.Dashboard.Invoice' |translate : 'Invoice queue' }}" matSort matSortActive="InvoiceAt" matSortDirection="asc" [filterFields]="['RegNo', 'OwnerId', 'DeliveryAddressCustomerName', 'DeliverAddress', 'CustomerNumber', 'Country', 'Method', 'VehicleId']">
        <ng-container matColumnDef="openOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">
            <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
              <mat-icon>search</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="EndContract">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }">
            <span *ngIf="row.TerminationId" (click)="showTermination(row.TerminationId)"><mat-icon>launch</mat-icon></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Method">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }">{{ row.Method }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="InvoiceAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_InvoiceAt' | translate : 'Invoice date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.InvoiceAt | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Price">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_Price' | translate : 'Price' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.Price | currency}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="RegNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{ row.RegNo }}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_Trailer_Model' | translate : 'Model' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{ row.Alias }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="VehicleId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_SerialNo' | translate : 'SerialNo' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.SerialNo}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="CustomerNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_CustomerNumber' | translate : 'Customer No' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.CustomerNumber}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="DeliveryAddressCustomerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_CustomerAddressDeliveryName' | translate : 'Customer' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddressCustomerName}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="DeliveryAddress">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_CustomerDeliveryAddress' | translate : 'Address' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddress}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_Country' | translate : 'Country' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.Country}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="OwnerId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.InvoicePipe_OwnerId' | translate : 'Owner' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Processed, blocked: row.IsBlocked }" (click)="openContractDialog(row.VehicleId)">{{row.OwnerId}}</mat-cell>
        </ng-container>
      </t4-data-table>
    </t4-container>
    <button *ngIf="enableMultiSelect && fullOrderSelection && !isReadOnly" (click)="delayInvoice()" mat-raised-button id="cmdExtend" style="margin: 15px;transform: translateY(-60px);" type="button">{{ 'TO_BackOffice_cmdPlusOneMonth' | translate : '+1 Month' }}</button>
    <button *ngIf="enableMultiSelect && fullOrderSelection && !isReadOnly" (click)="moveUpInvoice()" mat-raised-button id="cmdExtend" style="margin: 15px;transform: translateY(-60px);" type="button">{{ 'TO_BackOffice_cmdMinusOneMonth' | translate : '-1 Month' }}</button>
    <button *ngIf="enableMultiSelect && !fullOrderSelection && !invoiceNowSelection && !isReadOnly" (click)="markAsInvoiced()" mat-raised-button id="cmdExtend" style="margin: 15px;transform: translateY(-60px);" type="button">{{ 'TO_BackOffice_cmdConfirm' | translate : 'Confirm' }}</button>
    <button *ngIf="enableMultiSelect && invoiceNowSelection && !isReadOnly" (click)="invoiceNow()" mat-raised-button id="cmdExtend" style="margin: 15px;transform: translateY(-60px);" type="button">{{ 'TO_BackOffice_cmdConfirm' | translate : 'Confirm' }}</button>
    <div style="height: 30px"></div>
  </mat-tab>
  <mat-tab label="{{'TO.Dashboard.Repurchase' |translate : 'Repurchase queue' }}" *ngIf="!isReadOnly">
    <t4-container title="{{'TO.Dashboard.InvoiceDetails' |translate : 'Details' }}">
      <t4-data-table #tblRepurchase apiMethod="/TurboOrder/GetRepurchasePipe" [autoGenerateColumns]="false" matSort matSortActive="RepurchaseDate" matSortDirection="asc" headline="{{'TO.Dashboard.Repurchase' |translate : 'Repurchase queue' }}" [filterFields]="['RegNo', 'OwnerId', 'DeliveryAddressCustomerName', 'DeliverAddress', 'XALAccountNo']">
        <ng-container matColumnDef="openOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">
            <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
              <mat-icon>search</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="EndContract">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }">
            <span *ngIf="row.TerminationId" (click)="showTermination(row.TerminationId)"><mat-icon>launch</mat-icon></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="RepurchaseDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_OffRentDate' | translate : 'End date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.RepurchaseDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="XalAccountNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_XalAccountNo' | translate : 'Location id' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.XalAccountNo}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="DeliveryAddressCustomerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_CustomerAddressDeliveryName' | translate : 'Customer' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddressCustomerName}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="DeliveryAddress">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_CustomerDeliveryAddress' | translate : 'Address' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddress}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="RegNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{ row.RegNo }}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_Trailer_Model' | translate : 'Model' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{ row.Alias }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="OnRentDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_OnRentDate' | translate : 'Start date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.OnRentDate | date: 'yyyy-MM-dd'}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="OffRentDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_OffRentDate' | translate : 'End date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.OffRentDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="DLLContractId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_DllContractId' | translate : 'DLL number' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.DLLContractId}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="OwnerId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.RepurchasePipe_OwnerId' | translate : 'Owner' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.Repurchased }" (click)="openContractDialog(row.VehicleId)">{{row.OwnerId}}</mat-cell>

        </ng-container>
      </t4-data-table>
    </t4-container>
  </mat-tab>
  <mat-tab label="{{'TO.Dashboard.OffRentActions' |translate : 'Offrent queue' }}">
    <t4-container title="{{'TO.Dashboard.InvoiceDetails' |translate : 'Details' }}">
      <t4-data-table #tblOffRentActions apiMethod="/TurboOrder/GetOffrentPipe" [autoGenerateColumns]="false" headline="{{'TO.Dashboard.Repurchase' |translate : 'Repurchase queue' }}" matSort matSortActive="ActionDate" matSortDirection="asc" [filterFields]="['RegNo', 'OwnerId', 'DeliveryAddressCustomerName', 'DeliverAddress', 'XALAccountNo']">
        <ng-container matColumnDef="openOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">
            <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
              <mat-icon>search</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="EndContract">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }">
            <span *ngIf="row.TerminationId" (click)="showTermination(row.TerminationId)"><mat-icon>launch</mat-icon></span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Extension">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }">
            <mat-icon style="color:#1e9b38" *ngIf="row.ExtendToDate" title="{{ row.ExtendToDate | date: 'yyyy-MM-dd' }}">schedule</mat-icon>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="ActionDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_ActionDate' | translate : 'Action date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.ActionDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="ExtendToDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_ExtendToDate' | translate : 'Extend to' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.ExtendToDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="XalAccountNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_XalAccountNo' | translate : 'Location id' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.XalAccountNo}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="DeliveryAddressCustomerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_CustomerAddressDeliveryName' | translate : 'Customer' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddressCustomerName}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="DeliveryAddress">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_CustomerDeliveryAddress' | translate : 'Address' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.DeliveryAddress}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="RegNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_Trailer_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{ row.RegNo }}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_Trailer_Model' | translate : 'Model' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{ row.Alias }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="OnRentDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_OnRentDate' | translate : 'Start date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.OnRentDate | date: 'yyyy-MM-dd'}}</mat-cell>

        </ng-container>
        <ng-container matColumnDef="OffRentDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_OffRentDate' | translate : 'End date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.OffRentDate | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="DLLContractId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_DllContractId' | translate : 'DLL number' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.DLLContractId}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="OwnerId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.OffRentPipe_OwnerId' | translate : 'Owner' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.OwnerId}}</mat-cell>

        </ng-container>
      </t4-data-table>
    </t4-container>
  </mat-tab>
  <mat-tab label="{{'TO.Dashboard.NotTerminate' |translate : 'Not terminated' }}">
    <t4-container title="{{'TO.Dashboard.NotTerminate' |translate : 'Not terminated' }}">
      <t4-data-table #tblOffRentActions apiMethod="/TurboOrder/GetNotTerminated" [autoGenerateColumns]="false" headline="{{'TO.Dashboard.NotTerminate' }}" matSort matSortActive="ActionDate" matSortDirection="asc"
                           [filterFields]="['DeliveryAddressCustomerName', 'OwnerId', 'Country', 'DeliveryAddressCustomerName', 'XALAccountNo', 'RegNo', 'RentalId', 'Alias']">
        <ng-container matColumnDef="openOrder">
          <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="openContractDialog(row.VehicleId)">
            <a class="createSchedule" matTooltip="{{ 'Turbo.Core.ContractsHistory.Table_OpenOrder' | translate : 'Open order' }}">
              <mat-icon>search</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_Country' | translate : 'Country' }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.Country}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="DeliveryAddressCustomerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_CustomerName' | translate : 'Customer name' }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.DeliveryAddressCustomerName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="XalCustomerNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_CustomerNo' | translate : 'Customer number' }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            {{ row.XalCustomerNo}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="TerminateAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_TerminateAt' | translate : 'Termination date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="openContractDialog(row.VehicleId)">{{row.TerminateAt | date: 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_RentalId' | translate : 'Rental id' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="openContractDialog(row.VehicleId)">{{row.RentalId}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="RegNo">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_RegNo' | translate : 'Reg. no.' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{ row.RegNo }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_Model' | translate : 'Model' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{ row.Alias }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="OwnerId">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'TO.BackOffice.NotTerminated_OwnerId' | translate : 'Owner' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }" (click)="openContractDialog(row.VehicleId)">{{row.OwnerId}}</mat-cell>
        </ng-container>
      </t4-data-table>
    </t4-container>
  </mat-tab>
</mat-tab-group>
